import { createAction } from '@reduxjs/toolkit';

import type { FeeContent } from 'commons/modules/service/fee';

import { createReportSlice } from './reportStore';
import type { RootState } from './configureStore';

const initialFilters = {
  institute: '',
  advisor: '',
  account: '',
  client: '',
};

export const initialPageSize = 25;

// ======================================================
// 🔹 Acciones custom para fee
// ======================================================
export const setCommission = createAction<number>('fee/setCommission');
export const setPortfolioValue = createAction<number>('fee/setPortfolioValue');
export const setLayout = createAction<number>('fee/setLayout');
export const setDate = createAction<string>('fee/setDate');
export const setReprocessDate = createAction<{
  month: number | string;
  year: number | string;
}>('fee/setReprocessDate');

// ======================================================
// 🔹 Slice usando el store genérico
// ======================================================
const slice = createReportSlice<FeeContent>(
  'fee',
  initialFilters,
  (builder) => {
    builder
      .addCase(setCommission, (state, action) => {
        state.totalCommission = action.payload;
      })
      .addCase(setPortfolioValue, (state, action) => {
        state.totalPortfolioValue = action.payload;
      })
      .addCase(setLayout, (state, action) => {
        state.layoutName = action.payload;
      })
      .addCase(setDate, (state, action) => {
        state.filterDate = action.payload;
      })
      .addCase(setReprocessDate, (state, action) => {
        state.reprocessDate = action.payload;
      });
  },
  initialPageSize,
);

// ======================================================
// 🔹 Inicialización de campos custom
// ======================================================
const baseReducer = slice.reducer;
export default (state: any, action: any) => {
  if (state === undefined) {
    return baseReducer(
      {
        ...baseReducer(undefined, { type: '@@INIT' }),
        filterDate: '',
        reprocessDate: { month: 0, year: 0 },
        totalCommission: 0,
        totalPortfolioValue: 0,
        layoutName: 0,
      },
      action,
    );
  }
  return baseReducer(state, action);
};

// ======================================================
// 🔹 Selectores custom (los genéricos están en useReportStore)
// ======================================================

// Selectores específicos de fee (no están en el store genérico)
export const getDate = (state: RootState) =>
  state.entities.fee.filterDate || '';
export const getReprocessDate = (state: RootState) =>
  state.entities.fee.reprocessDate || { month: 0, year: 0 };
export const getCommission = (state: RootState) =>
  state.entities.fee.totalCommission || 0;
export const getLayout = (state: RootState) =>
  state.entities.fee.layoutName || 0;
export const getPortfolioValue = (state: RootState) =>
  state.entities.fee.totalPortfolioValue || 0;
